import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { Faq } from "@/domain/faq.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class FaqService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: Faq): Promise<Faq> => {
    return httpClient
      .request<Faq>({
        url: `${this.urlApiBase}/faq`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: Faq): Promise<Faq> => {
    return httpClient
      .request<Faq>({
        url: `${this.urlApiBase}/faq/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<Faq> => {
    const url = `${this.urlApiBase}/faq/${id}`;

    return httpClient
      .request<Faq>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ): Promise<IPaginateVueTable<Faq>> => {
    const query = formatQueryString(offset, limit, order, sort, filter);
    const url = `${this.urlApiBase}/faq${query}`;

    return httpClient
      .request<IPaginateVueTable<Faq>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<Faq[]> => {
    const url = `${this.urlApiBase}/faq/list-active`;

    return httpClient
      .request<Faq[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<Faq> => {
    const url = `${this.urlApiBase}/faq/${id}`;

    return httpClient
      .request<Faq>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
